import React, { useEffect, useState } from 'react';
import { getParamsFromUrl } from '../../utilities/urlResolver';
import FadeTransition from '../animations/FadeTransition';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';
import {parseStringToJson} from "../../utilities/helpers";

const SplashScreen = () => {
  const [showSplash, setShowSplash] = useState(window.sessionStorage.getItem('showSplash') !== 'false' && Object.keys(getParamsFromUrl()).length <= 1);
  const isMobile = window.innerWidth <= 768;
  const { default_photo_url, locale } = window.holidayFinder;
  const splashScreenLink = parseStringToJson(default_photo_url)?.[locale]?.[0]?.splash;

  useBodyScrollLock({ condition: showSplash, mobileOnly: true });

  useEffect(() => {
    let timeout;

    if (isMobile) {
      timeout = setTimeout(() => {
        setShowSplash(false);
      }, 3500);
      window.sessionStorage.setItem('showSplash', false);
    }

    return () => {
      clearTimeout(timeout);
    }
  }, [isMobile])

  if (!isMobile || !splashScreenLink) return '';

  return (
    <FadeTransition
      in={showSplash}
      unmountOnExit
      timeout={1000}
    >
      <div className="splash-screen">
        <object type="image/svg+xml" data={splashScreenLink}>Holiday Finder</object>
      </div>
    </FadeTransition>
  )
}

export default SplashScreen;
